"use strict";

exports.__esModule = true;
exports.FadeIn = undefined;

var _FadeIn = require("./FadeIn");

var _FadeIn2 = _interopRequireDefault(_FadeIn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _FadeIn2.default;
exports.FadeIn = _FadeIn2.default;


//////////////////
// WEBPACK FOOTER
// ./~/react-lazyload-fadein/lib/index.js
// module id = 123
// module chunks = 213534597649335 259173521737895